import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
//import { Observable } from 'rxjs/Observable';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/catch';
//import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class LoginService {

    nomeUsuario = null;

    constructor(private http: Http) {}

    estaLogado(): boolean {
        let axLogin = null;

        if ( localStorage.getItem('usuarioLogado') !== null ) {
            axLogin = JSON.parse(localStorage.getItem('usuarioLogado'));
            if ( axLogin.logado === true ) {
                this.nomeUsuario = axLogin.usuarioSistema.Nome;
                return true;
            }
        }
        return false;
    }

    autenticaLogin(usuarioSistema, loginForm): boolean {
        if ( usuarioSistema.length === 1) {
          if (usuarioSistema[0].Senha === loginForm.Senha) {
            // Mock-up sem encriptografia dos dados, alterar forma de gravar para produção
            localStorage.setItem('usuarioLogado', JSON.stringify({
                usuarioSistema: usuarioSistema[0],
                logado: true
              }));
            return true;
          }
        }

        return false;
      }

    logoff() {
        localStorage.setItem('usuarioLogado', JSON.stringify({
          usuarioSistema: null,
          logado: false
        }));
    }

    getNomeUsuario() {
        return this.nomeUsuario;
    }

}



// WEBPACK FOOTER //
// ./src/app/login/login.service.ts